module.exports = __webpack_public_path__ + "static/media/boon_logo.b2aac574.svg";